import { QRCode } from "./qrcode"
// import { PrintCanvasRenderer } from "./DataToImageCapability"
import { PrintCanvasRenderer } from "@sm/max-converter"

/**
 * @dtsModule max.converter
 * @dtsNamespace converter
 * @dtsDesc converter Converter
 */
export const converter = {
  /**
   * @dtsExport
   * Convert a string to a QR code
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.converter.qrCode&lang=%{locale}%)
   */
  async qrCode(str: string, options?: {
    codeSize?: number // 二维码边长，非必传
    icon?: string // 二维码中心图片地址，非必传
    imageScale?: number // 图片比例大小，非必传 默认 20%
    // L级：最大可以被遮挡 7% 的内容. M 级：最大可以被遮挡 15% 的内容. Q 级：最大可以被遮挡 25% 的内容. H 级：最大可以被遮挡 30% 的内容。
    errorLevel?: "L" | "M" | "Q" | "H" // 二维码容错等级，默认"Q"
    backgroundColor?: "black" | "white" // 背景色,默认"white"
    codeColor?: "black" | "white" // 码底色,默认 "black"
  }
  ): Promise<string> {
    const {
      codeSize = 200,
      icon,
      imageScale = 20,
      errorLevel = "Q",
      backgroundColor = "white",
      codeColor = "black",
    } = options || {}

    const colorToHexProxy = {
      "white": '#FFF',
      "black": '#000',
    }

    let canvas: HTMLCanvasElement | null = null
    let ctx: CanvasRenderingContext2D | null = null

    try {
      if (str == "" || typeof str !== "string")
        throw Error("Parameter must be of string type and cannot be empty.")
      // 判断二维码宽高
      if (codeSize < 0 || codeSize > 2000) {
        throw Error(
          "The QR code size cannot exceed 2000 and cannot be less than 0"
        )
      }
      if (imageScale < 0 || imageScale > 50) {
        throw Error(
          `The image ratio cannot exceed 50% and cannot be less than 0%. imageScale:${imageScale}`
        )
      }

      // 创建画布
      canvas = document.createElement('canvas')
      ctx = canvas.getContext('2d')
      if (!ctx) {
        throw new Error('Failed to get canvas context')
      }

      canvas.width = codeSize
      canvas.height = codeSize

      // 设置背景色
      ctx.fillStyle = colorToHexProxy[backgroundColor]
      ctx.fillRect(0, 0, codeSize, codeSize)

      // 生成二维码
      await (QRCode as any)?.toCanvas?.(canvas, str, {
        width: codeSize,
        errorCorrectionLevel: errorLevel,
        margin: 2,
        color: {
          dark: colorToHexProxy[codeColor],
          light: colorToHexProxy[backgroundColor]
        }
      })

      if (!icon) return canvas.toDataURL('image/png')

      // 加载并绘制图标
      const iconImg = new Image()
      iconImg.crossOrigin = 'anonymous'
      await new Promise((resolve, reject) => {
        iconImg.onload = resolve
        iconImg.onerror = reject
        iconImg.src = icon
      })

      // 计算图标尺寸和位置
      const iconSize = (codeSize * imageScale) / 100
      const iconX = (codeSize - iconSize) / 2
      const iconY = (codeSize - iconSize) / 2

      // 绘制图标
      ctx.drawImage(iconImg, iconX, iconY, iconSize, iconSize)

      return canvas.toDataURL('image/png')
    } catch (e) {
      throw Error(e)
    } finally {
      // 清理资源
      if (canvas) {
        canvas.width = 0
        canvas.height = 0
        canvas = null
      }
      ctx = null
    }
  },
  /**
   * @dtsExport
   */
  async previewPrint(data: any[], config?: {
    width?: number,
    height?: number,
    marginLeft?: number,
    marginTop?: number,
    marginRight?: number,
    marginBottom?: number,
    // printMode?: 'cmd' | 'bmd',
    // rotate?: 0 | 180,
    type?: 'receipt' | 'label',
  }): Promise<string> {
    const renderer = new PrintCanvasRenderer({
      ...config, showCutPaper: false,
      showBoundsLine: false
    } as any)
    const result: string = await renderer.render(data)
    return result
  }
}
